// composables/useDateUtils.js
export const useDateUtils = () => {
  const { t, locale } = useI18n()

  const setTimeString = (from, to) => {
    if (!from) return ''

    const fromDate = new Date(from)
    const toDate = to ? new Date(to) : null

    const formatSingleDate = (date) => {
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      }

      const timeOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: locale.value === 'en',
        timeZone: 'UTC',
      }

      const formattedDate = new Intl.DateTimeFormat(
        locale.value,
        dateOptions
      ).format(date)

      const formattedTime = new Intl.DateTimeFormat(
        locale.value,
        timeOptions
      ).format(date)

      return `${formattedDate} ${t('notices.from')} ${formattedTime}`
    }

    const fromString = formatSingleDate(fromDate)

    if (!toDate || fromDate.toDateString() === toDate.toDateString()) {
      return fromString
    } else {
      const toDateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      }
      const formattedToDate = new Intl.DateTimeFormat(
        locale.value,
        toDateOptions
      ).format(toDate)

      return `${fromString} - ${formattedToDate}`
    }
  }

  return { setTimeString }
}
